import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: 0,
  loading: false,
}

export const IncrementDecrementSlice = createSlice({
  name: 'IncrementDecrement',
  initialState,
  reducers: {
   
    Increment_Decrement_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      
    }
  }
})

// Action creators are generated for each case reducer function
export const {Increment_Decrement_success } = IncrementDecrementSlice.actions

export default IncrementDecrementSlice.reducer